module.exports = {"410172160":"石佛镇","410172360":"沟赵乡","410172560":"枫杨街道","410172561":"梧桐街道","410172562":"双桥街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410172.json
// module id = 1640
// module chunks = 0